import React, { useEffect, useState } from "react";
import { compose } from "redux";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import affiliatesConnector from "../../services/affiliates/connector";

const Affiliates = ({ affiliates, createAffiliate, getAffiliates }) => {
  const [ownerPersonId, setOwnerPersonId] = useState("");
  const [affiliateName, setAffiliateName] = useState("");

  useEffect(() => {
    if (affiliates.fetched === false) getAffiliates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div style={{ padding: "20px 0" }}>
        <h3>Add new affiliate</h3>
      </div>
      Affiliate visits are tracked even for affiliates who are not added, but
      only added affiliates will give investors a reward referral.
      <br />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="OwnerPersonId"
        value={ownerPersonId}
        variant="outlined"
        onChange={(event) => setOwnerPersonId(event.target.value)}
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="AffiliateName"
        value={affiliateName}
        onChange={(event) => setAffiliateName(event.target.value)}
        variant="outlined"
      />
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => _createAffiliate(ownerPersonId, affiliateName)}
      >
        Create new affiliate
      </Button>
      {affiliates.error && (
        <div style={{ color: "red" }}>{affiliates.error}</div>
      )}
      <div style={{ padding: "5px 0" }}>
        <h3>Recognized affiliates:</h3>
      </div>
      {affiliates &&
        affiliates.data &&
        affiliates.data.map((affiliate) => {
          return (
            // eslint-disable-next-line react/jsx-key
            <h4 style={{ padding: "2px 5px" }}>
              {affiliate.Name}
              <br />
            </h4>
          );
        })}
    </React.Fragment>
  );

  function _createAffiliate(ownerPersonId, affiliateName) {
    createAffiliate(ownerPersonId, affiliateName);
    clearFields();
  }

  function clearFields() {
    setOwnerPersonId("");
    setAffiliateName("");
  }
};

export default compose(affiliatesConnector)(Affiliates);
